import React, { useMemo, useState } from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import MarketerNoLoginAdCallList from '../../components/admin/marketer/MarketerNoLoginAdCallList';
import '../../styles/admin/AdminSummary.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdvertiserAdCallCheckPage() {
  const [selected, setSelected] = useState(null); // {_id, managerName, contact, companyName, content, createdAt}
  const [refreshToken, setRefreshToken] = useState(0);
  const [loading, setLoading] = useState(false);

  const contentPreview = useMemo(() => {
    const c = String(selected?.content || '');
    if (c.length <= 1000) return c;
    return c.slice(0, 1000) + '\n\n... (이하 생략: 전체보기로 확인하세요)';
  }, [selected]);

  const openFullContent = () => {
    const w = window.open('about:blank', '_blank', 'width=800,height=600');
    if (!w) {
      alert('팝업이 차단되었어요. 브라우저에서 팝업을 허용한 뒤 다시 시도해주세요.');
      return;
    }
    const raw = String(selected?.content || '');
    const escaped = raw.replace(/[&<>]/g, m => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;' }[m]));
    const html = `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
    <title>문의 내용 전체보기</title>
    <style>
      html, body { height:100%; margin:0; padding:0; }
      body { font-family: system-ui,-apple-system, Segoe UI, Roboto, sans-serif; box-sizing:border-box; max-width:100vw; overflow-x:hidden; }
      .wrap { box-sizing:border-box; padding:16px; max-width:100vw; }
      .title { margin:0 0 12px 0; }
      .content {
        white-space: pre-wrap;
        word-break: break-word;
        overflow-wrap: anywhere;
        line-height: 1.6;
        max-height: calc(100vh - 72px);
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid #eee;
        padding: 12px;
        border-radius: 6px;
      }
    </style>
  </head>
  <body>
    <div class="wrap">
      <h2 class="title">문의 내용</h2>
      <div class="content">${escaped}</div>
    </div>
  </body>
</html>`;
    try {
      w.document.open(); w.document.write(html); w.document.close();
    } catch {
      const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      w.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    }
  };

  const handleDone = async () => {
    if (!selected?._id) return;
    if (!window.confirm('해당 광고대행 문의를 처리 완료로 변경할까요?')) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/adcall/${selected._id}/done`, {
        method: 'POST',
        credentials: 'include'
      });
      const data = await res.json().catch(()=>({}));
      if (res.ok && data?.ok) {
        setSelected(null);
        setRefreshToken(t => t + 1); // 좌측 목록 새로고침(완료 항목 제외됨)
      } else {
        alert(data?.message || '완료 처리 실패');
      }
    } catch {
      alert('요청 실패');
    }
    setLoading(false);
  };

  return (
    <AdminLayout title="광고대행 문의(비로그인) 관리">
      <div className="admin-grid">
        <div className="admin-section" style={{ height: 'calc(100vh - 120px)' }}>
          <MarketerNoLoginAdCallList
            interactive={true}
            onSelect={(u) => setSelected(u)}
            selectedId={selected?._id || `${selected?.managerName || ''}-${selected?.createdAt || ''}`}
            refreshToken={refreshToken}
          />
        </div>

        <div className="admin-section admin-section--wide" style={{ height: 'calc(100vh - 120px)', overflowY: 'auto' }}>
          <h3 className="admin-summary__title">문의 상세 내용</h3>
          {!selected ? (
            <div className="admin-summary__empty" style={{ marginTop: '20px' }}>좌측에서 문의 내역을 선택하세요.</div>
          ) : (
            <>
              <div style={{ lineHeight: 2, fontSize: '14px', color: 'var(--admin-text-body)' }}>
                <div><strong>문의자</strong>: {selected.managerName}</div>
                <div><strong>연락처</strong>: {selected.contact}</div>
                <div><strong>회사명</strong>: {selected.companyName}</div>
                <div><strong>상태</strong>: <span className={`admin-list__item-badge ${selected.status === 'done' ? 'admin-list__item-badge--success' : 'admin-list__item-badge--warning'}`}>{selected.status === 'done' ? '완료' : '대기'}</span></div>
                <div><strong>접수일시</strong>: {selected.createdAt ? new Date(selected.createdAt).toLocaleString() : ''}</div>
              </div>

              <div style={{ marginTop: 20 }}>
                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: '14px' }}>문의 내용</div>
                <div style={{ 
                  whiteSpace: 'pre-wrap', 
                  wordBreak: 'break-word', 
                  overflowX: 'hidden', 
                  overflowY: 'auto', 
                  border: '1px solid var(--admin-border-color)', 
                  padding: 16, 
                  borderRadius: 6, 
                  maxHeight: 320,
                  background: 'var(--admin-bg-input)',
                  fontSize: '14px',
                  lineHeight: '1.5'
                }}>
                  {contentPreview}
                </div>
                <div className="admin-section__actions" style={{ justifyContent: 'flex-end', marginTop: 16 }}>
                  <button className="admin-section__button admin-section__button--secondary" type="button" onClick={openFullContent}>
                    전체보기
                  </button>
                  <button
                    className="admin-section__button"
                    type="button"
                    onClick={handleDone}
                    disabled={loading}
                    style={{ backgroundColor: selected.status === 'done' ? '#ccc' : 'var(--admin-color-success)', borderColor: selected.status === 'done' ? '#ccc' : 'var(--admin-color-success)' }}
                  >
                    처리 완료
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdvertiserAdCallCheckPage;
